const ChildWeddingFormTranslations = {
    en: {
        labels: {
            title: "Children's Wedding Planning",
            description: "Plan for your children's future wedding expenses.",
            form_timestamp: "Form Timestamp",
            name: "Name",
            email: "Email",
            mobile: "Mobile",
            city_of_residence: "City of Residence",
            otherCity: "Other City",
            gender: "Gender", // This refers to the customer's gender
            dob: "Date of Birth",
            yourAgeIs: "Your Age is",
            marital_status: "Marital Status",
            selectOption: "Select an option",
            next: "Next",
            reset_all: "Reset All",
            children_details: "Children's Details",
            number_of_children: "Number of Children (Max 5)",
            generate_child_forms: "Generate Child Forms",
            go_back_personal_details: "Go Back to Personal Details",
            child_number: "Child",
            child_name: "Name", // This refers to the child's name
            age: "Current Age", // This refers to the child's age
            currentGoldCostInr: "Current Gold Cost (INR)",
            currentWeddingCostInr: "Current Wedding Cost (INR)",
            calculate: "Submit",
            calculate1: "Calculate",
            submit_form: "Submit Wedding Plan",
            assumptions: "Assumptions",
            goldInflation: "Gold Inflation",
            weddingInflation: "Wedding Inflation",
            weddingAge: "Wedding Age",
            years: "Years",
            crores: "Crores",
            lakhs: "Lakhs",
            submission_success: "Wedding plan submitted successfully!",
        },
        placeholders: {
            name: "Enter your name",
            email: "Enter your email",
            mobile: "Enter your mobile number",
            city_of_residence: "Select your city",
            otherCity: "Enter your city",
            gender: "Select your gender",
            dob: "Select your Date of Birth",
            number_of_children: "Select number of children",
            child_name: "Enter child's name",
            age: "Enter child's current age",
            currentGoldCostInr: "Enter current gold cost (INR)",
            currentWeddingCostInr: "Enter current wedding cost (INR)",
        },
        errors: {
            nameRequired: "Name is required.",
            emailRequired: "Email is required.",
            invalidEmail: "Please enter a valid email address.",
            mobileRequired: "Mobile number is required.",
            invalidMobile: "Please enter a valid 10-digit mobile number (no more than 3 repeating digits).",
            cityRequired: "City of residence is required.",
            requiredOtherCity: "Please specify your city.",
            dobRequired: "Date of Birth is required.",
            dateInvalid: "Invalid date or future date.",
            genderRequired: "Gender is required.",
            maritalStatusRequired: "Marital status is required.",
            invalidNumberOfChildren: "Please enter a number between 1 and 5.",
            numberOfChildrenRequired: "Please specify the number of children and generate their forms first.",
            childNameRequired: "Child's name is required.",
            invalidChildAge: "Child's age must be between 1 and 26.",
            invalidGoldCost: "Gold Cost must be a positive number.",
            invalidWeddingCost: "Wedding Cost must be a positive number.",
            validationFailed: "Please correct the errors in the details.",
            submitError: "Failed to submit data. Please try again.",
        },
        data: {
            cityOptions: [
                { value: 'Bengaluru', label: 'Bengaluru' },
                { value: 'Chennai', label: 'Chennai' },
                { value: 'Mumbai', label: 'Mumbai' },
                { value: 'Delhi', label: 'Delhi' },
                { value: 'Kolkata', label: 'Kolkata' },
                { value: 'Hyderabad', label: 'Hyderabad' },
                { value: 'Pune', label: 'Pune' },
                { value: 'Ahmedabad', label: 'Ahmedabad' },
                { value: 'Jaipur', label: 'Jaipur' },
                { value: 'Lucknow', label: 'Lucknow' },
                { value: 'Others', label: 'Others' }
            ],
            customerGenderOptions: [ // For the customer (parent)
                { value: 'Male', label: 'Male' },
                { value: 'Female', label: 'Female' },
                { value: 'Other', label: 'Other' }
            ],
            childGenderOptions: [ // For the child
                { value: 'Male', label: 'Male' },
                { value: 'Female', label: 'Female' }
            ],
            maritalStatusOptions: [
                { value: 'Single', label: 'Single' },
                { value: 'Married', label: 'Married' },
                { value: 'Divorced', label: 'Divorced' },
                { value: 'Widowed', label: 'Widowed' }
            ],
            numberOfChildrenOptions: [ 1, 2, 3, 4, 5] // Max 5 children
        }
    }
};

export default ChildWeddingFormTranslations;